import 'react';
import { useApolloClient } from '@apollo/client';

var useFetchCacheQuery = function useFetchCacheQuery() {
  var client = useApolloClient();
  client.defaultOptions = {
    watchQuery: {
      fetchPolicy: 'cache-first'
    }
  };
  return client.query;
};

export { useFetchCacheQuery as u };
